$(document).ready(function( $ ){ 
 $('.js-collection-section-expand').click(function (e) 
 {
   if ($(this).parent('.content-section').hasClass("expand")) {
     $(this).parent('.content-section').removeClass("expand")
     $(this).html("Read More")

    // $("html, body").animate({ scrollTop: 0 }, "slow");
    jQuery('html, body').stop().animate({
      scrollTop: $('.collection-information').offset().top-100
    }, 1000, 'linear');
  }
  else
  {
   $(this).parent('.content-section').addClass("expand")
   $(this).html("[x] Close")
 }



})
})


jQuery(document).ready(function ($) {
  // Mega Menu
  $('.mega-menu__tabs .menu.active').fadeIn(200);
  $('.mega-menu__tabs .tabs__list button').on('click', function (e) {
    e.preventDefault();
    var dataTab = $(this).data('tab-index');
    $('.mega-menu__tabs .tabs__list button').removeClass('active');
    $(this).addClass('active');
    $('.mega-menu__tabs .menu.active').fadeOut(200, function () {
      $('.mega-menu__tabs .menu[data-tab-index="' + dataTab + '"]').fadeIn(200).addClass('active');
      $('.mega-menu__tabs .menu[data-tab-index="' + dataTab + '"] .slider');
    }).removeClass('active');
  }); 

// Mobile Menu Panels
  // click menu item with children, close main menu, open matching sub panel

  $('.mobile-menu .nav--main a').on('click', function (e) {
    if ($(this).closest('li').hasClass('has-children')) {
      e.preventDefault();
      var dataMenu = $(this).data('menu-index');
      $('.mobile-menu__main').fadeOut('fast', function () {
        $('.mobile-menu__sub .nav__page[data-menu-index="' + dataMenu + '"]').fadeIn('fast');
      });
    }
  }); // close sub panel, open main menu

  $('.mobile-menu__sub .heading').on('click', function (e) {
    e.preventDefault();
    var dataParentMenu = $(this).closest('.nav__page').data('menu-index');
    $(this).closest('.nav__page').fadeOut('fast', function () {
      $('.mobile-menu__main').fadeIn('fast');
    });

  });

}); 